import router from "@/router";
import { artistSlug } from "@/services/editorialArtists";

// La ficha del artista, abierta desde donde sea.
//
// 🔴 **Desde el 30.09.26 es una página, no un diálogo.** Decisión de Pablo:
// «todo nombre de artista que se pulsa abre su ficha» —la de Radar si el
// artista es de Radar, la de rotación si no—. Entrega
// `docs/entregas/2026-09-30-la-ficha-del-artista-de-rotacion-es-una-pagina.md`.
//
// Hasta ese día esto guardaba un estado compartido que `App.vue` leía para
// montar un único `ArtistDialog` encima de Radio (16.09.26). El diálogo se
// retira y este composable se queda como **la única puerta**: la portada,
// Radio, «Lo que sigue» y «Acabas de escuchar» siguen llamando a `abrir()` sin
// cambiar una línea, y lo que cambia es a dónde lleva.
//
// Quién es de Radar lo decide la ficha del servidor (`origen`, §2.2d), no esta
// función: aquí solo se calcula el slug y se navega. `ArtistaView` redirige a
// la de Radar si toca.
export function useFichaArtista() {
  /**
   * Lleva a la ficha de alguien.
   *
   * @param {string} nombre el del artista, tal como se ve en pantalla. Del
   *   nombre sale el slug con el algoritmo del contrato (§3), el mismo con el
   *   que el servidor guarda la ficha.
   */
  function abrir(nombre) {
    const slug = artistSlug(String(nombre || "").trim());
    // Sin nombre no hay a dónde ir, y una página vacía es peor que no moverse.
    if (!slug) return;
    router.push(`/artista/${slug}`);
  }

  return { abrir };
}
